$(document).ready(function(){ 
    // Sayfa yüklendiğinde Türkiye'yi seç
    $('#country-name').val('223').change(); 
    
    // GA4 tracking'i bir kez setup et
    setupStoreTracking();
});

// GLOBAL GA4 Event Tracking Setup - Sadece bir kez çalışır
function setupStoreTracking() {
    // Önceki event listener'ları temizle (çoklanmayı önle)
    $(document).off('click.storeTracker');
    
    console.log('GA4 Store Tracking initialized');
    
    // Event delegation ile - yeni eklenen elementler için de çalışır
    $(document).on('click.storeTracker', '.get-direction-btn', function(e) {
        e.preventDefault(); // Sayfa değişimini önle
        
        var storeName = $(this).data('store');
        var href = this.href;
        
        console.log('🗺️ Direction clicked:', storeName); // Debug log
        
        // GA4 Event gönder
        if (typeof gtag !== 'undefined') {
            gtag('event', 'get_direction', {
                'event_category': 'Store Locator',
                'store_name': storeName,
                'link_url': href
            });
            console.log('✅ GA4 get_direction event sent');
        } else {
            console.error('❌ gtag not available');
        }
        
        // 150ms bekleyip link'i aç (GA4 event'inin gönderilmesi için)
        setTimeout(function() {
            window.open(href, '_blank');
        }, 150);
    });

    $(document).on('click.storeTracker', '.whatsapp-btn', function(e) {
        var storeName = $(this).data('store');
        
        console.log('💬 WhatsApp clicked:', storeName);
        
        if (typeof gtag !== 'undefined') {
            gtag('event', 'whatsapp_contact', {
                'event_category': 'Store Locator',
                'store_name': storeName,
                'link_url': this.href
            });
            console.log('✅ GA4 whatsapp_contact event sent');
        }
        // WhatsApp link normal çalışır (target="_blank" var)
    });

    $(document).on('click.storeTracker', '.phone-call-btn', function(e) {
        var storeName = $(this).data('store');
        
        console.log('📞 Phone clicked:', storeName);
        
        if (typeof gtag !== 'undefined') {
            gtag('event', 'phone_call', {
                'event_category': 'Store Locator',
                'store_name': storeName,
                'phone_number': this.href.replace('tel:', '')
            });
            console.log('✅ GA4 phone_call event sent');
        }
        // Telefon link'i normal çalışır
    });
}

// Ülke değişimi event listener
jQuery(document).on('change', 'select#country-name', function (e) {
    e.preventDefault();
    var countryID = jQuery(this).val();
    console.log('Country changed:', countryID);
    getStatesList(countryID);
});

// Şehir değişimi event listener
jQuery(document).on('change', 'select#state-name', function (e) {
    e.preventDefault();
    var stateID = jQuery(this).val();
    console.log('State changed:', stateID);
    getCityList(stateID);
});

// İlleri getir
function getStatesList(countryID) {
    $.ajax({
        url: "https://store.cilek.com/location/getstates",
        type: 'post',
        data: {countryID: countryID},
        dataType: 'json',
        beforeSend: function () {
            jQuery('select#state-name').find("option:eq(0)").html("Please wait..");
        },
        complete: function () {
            // İsteğe bağlı: complete handler
        },
        success: function (json) {
            var options = '';
            options += '<option value="">Seçiniz</option>';
            
            for (var i = 0; i < json.length; i++) {
                options += '<option value="' + json[i].state_id + '">' + json[i].state_name + '</option>';
            }
            
            jQuery("select#state-name").html(options);
            console.log('States loaded:', json.length);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.error('States loading error:', thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
    });
}

// Mağazaları getir
function getCityList(stateID) {
    $.ajax({
        url: "https://store.cilek.com/location/getcities",
        type: 'post',
        data: {stateID: stateID},
        dataType: 'json',
        beforeSend: function () {
            jQuery('#city-name').find("option:eq(0)").html("Please wait..");
        },
        complete: function () {
            // İsteğe bağlı: complete handler
        },
        success: function (json) {
            var stores = '';

            for (var i = 0; i < json.length; i++) {
                var storeName = json[i].city_name;
                var hasWhatsApp = json[i].city_description && json[i].city_description !== "";
                var latitude = json[i].city_latitude;
                var longitude = json[i].city_longitude;
                var address = json[i].city_address;
                var phone1 = json[i].city_phone;
                var phone2 = json[i].city_phone_2;

                if (!hasWhatsApp) {
                    // WhatsApp olmayan mağazalar
                    stores += '' +
                        '<div style="grid-template-rows: auto;" class="smargin grid__item small--one medium-up--one-quarter">' +
                        '<div>' +
                        '<h3 class="title"><a href="https://maps.google.com/maps?q=' + latitude + ',' + longitude + '">' +
                            storeName +
                        '</a></h3>' +
                        '<p class="location-adress">' +
                            address +
                        '</p>';
                    
                    // Telefon 1 (varsa)
                    if (phone1 && phone1 !== '') {
                        stores += '<p class="wp-link_store0" style="margin-bottom: 20px;"> <a href="tel:' + phone1 + '" class="phone-call-btn" data-store="' + storeName + '"> ' +
                            phone1 +
                        '</a></p>';
                    }
                    
                    // Telefon 2 (varsa)
                    if (phone2 && phone2 !== '') {
                        stores += '<p class="wp-link_store0" style="margin-bottom: 20px;"> <a href="tel:' + phone2 + '" class="phone-call-btn" data-store="' + storeName + '"> ' +
                            phone2 +
                        '</a></p>';
                    }
                    
                    stores += '</div>' +
                        '<div>' +
                        '<a class="btn get-direction-btn" href="https://maps.google.com/maps?q=' + latitude + ',' + longitude + '" role="button" data-store="' + storeName + '">Yol Tarifi</a>' +
                        '</div>' +
                        '</div>';
                        
                } else {
                    // WhatsApp olan mağazalar
                    stores += '' +
                        '<div style="grid-template-rows: auto;" class="smargin grid__item small--one medium-up--one-quarter">' +
                        '<div>' +
                        '<h3 class="title"><a href="https://maps.google.com/maps?q=' + latitude + ',' + longitude + '">' +
                            storeName +
                        '</a></h3>' +
                        '<p class="location-adress">' +
                            address +
                        '</p>' +
                        '<p class="wp-link_store1" style="margin-bottom: 20px;"><img class="wp-icon_store" src="https://cdn.shopify.com/s/files/1/0267/7548/6653/files/whatsapp-store.png?v=1654860038"><a target="_blank" class="wp_link whatsapp-btn" href="https://wa.me/' + json[i].city_description + '?text=Merhaba" data-store="' + storeName + '"> ' +
                            "WhatsApp İletişim" +
                        '</a></p>';
                    
                    // Telefon 1 (varsa)
                    if (phone1 && phone1 !== '') {
                        stores += '<p class="wp-link_store0" style="margin-bottom: 20px;"> <a href="tel:' + phone1 + '" class="phone-call-btn" data-store="' + storeName + '"> ' +
                            phone1 +
                        '</a></p>';
                    }
                    
                    // Telefon 2 (varsa)
                    if (phone2 && phone2 !== '') {
                        stores += '<p class="wp-link_store0" style="margin-bottom: 20px;"> <a href="tel:' + phone2 + '" class="phone-call-btn" data-store="' + storeName + '"> ' +
                            phone2 +
                        '</a></p>';
                    }
                    
                    stores += '</div>' +
                        '<div>' +
                        '<a class="btn get-direction-btn" href="https://maps.google.com/maps?q=' + latitude + ',' + longitude + '" role="button" data-store="' + storeName + '">Yol Tarifi</a>' +
                        '</div>' +
                        '</div>';
                }
            }
          
            jQuery("#city-name").html(stores);
            
            // ÖNEMLİ: Event listener'ları burada EKLEME! 
            // Çünkü global olarak setupStoreTracking() ile tanımlandılar
            
            console.log('✅ Cities loaded successfully. Store count:', json.length);
            console.log('📍 Direction buttons available:', $('.get-direction-btn').length);
            console.log('💬 WhatsApp buttons available:', $('.whatsapp-btn').length);
            console.log('📞 Phone buttons available:', $('.phone-call-btn').length);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.error('Cities loading error:', thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
    });
}

// Debug ve Test Fonksiyonu
function testGA4Tracking() {
    console.log('=== GA4 TRACKING TEST ===');
    
    // 1. Temel kontroller
    console.log('✓ jQuery available:', typeof $ !== 'undefined');
    console.log('✓ gtag available:', typeof gtag !== 'undefined');
    console.log('✓ dataLayer available:', window.dataLayer ? 'YES (' + window.dataLayer.length + ' items)' : 'NO');
    
    // 2. Element sayıları
    console.log('📍 Direction buttons:', $('.get-direction-btn').length);
    console.log('💬 WhatsApp buttons:', $('.whatsapp-btn').length);
    console.log('📞 Phone buttons:', $('.phone-call-btn').length);
    
    // 3. Manuel test eventi
    if (typeof gtag !== 'undefined') {
        gtag('event', 'tracking_test', {
            'event_category': 'Debug',
            'test_timestamp': new Date().toISOString(),
            'page_url': window.location.href
        });
        console.log('✅ Test event sent to GA4');
    } else {
        console.error('❌ Cannot send test event - gtag not available');
    }
    
    // 4. İlk buton test (varsa)
    if ($('.get-direction-btn').length > 0) {
        console.log('🧪 Simulating click on first direction button...');
        setTimeout(function() {
            $('.get-direction-btn').first().click();
        }, 1000);
    } else {
        console.log('ℹ️ No direction buttons found - select a city first');
    }
    
    console.log('=== TEST COMPLETED ===');
}

// Console'dan çağırabilmek için global olarak tanımla
window.testGA4Tracking = testGA4Tracking;